<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("graduation_category.manage_graduation") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="showModal"
    >
      {{ $t("common.add_new") }}
    </md-button>
    <add-page ref="modalRef" :name="name" :title="title"></add-page>
  </div>
</template>

<script>
import AddPage from "../../GraduationCategories/AddPage.vue";
import { GraduationCategory } from "@/constants/Permissions";

export default {
  components: { AddPage },
  name: "ListPageHeader",
  data() {
    return {
      name: "addPage",
      title: "graduation_category.add_new_graduation",
      GraduationCategory
    };
  },
  computed: {
    canAdd() {
      return this.$can(
        GraduationCategory.actions.add,
        GraduationCategory.subject
      );
    }
  },
  methods: {
    showModal() {
      this.$refs.modalRef.clearData();
      this.$modal.show(this.name);
    }
  }
};
</script>
